import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import sigmaLogo from "../Images/sigma-bank-logo.png";

function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    const { resetPassword } = useAuth();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage('');
        setError('');

        if (!email) {
            setError('Please enter your email address to continue.');
            setLoading(false);
            return;
        }

        const { error: resetError } = await resetPassword(email);

        if (resetError) {
            setError(resetError);
        } else {
            setMessage('Password reset instructions have been sent to your email. Please check your inbox and follow the link to reset your password.');
            setEmail('');
        }

        setLoading(false);
    };

    return (
        <main className="main-sectionWrapper">
            <div id="main-section" style={styles.mainSection}>
                <div style={styles.background}></div>

                <div style={styles.container}>
                    <div style={styles.brandContainer}>
                        <div style={styles.logoCircle}>
                            <img src={sigmaLogo} alt="Sigma Bank" style={styles.logoImage} />
                        </div>
                        <p style={styles.brandTagline}>Ethereum Wallet Platform</p>
                    </div>

                    <div style={styles.authCard}>
                        <div style={styles.welcomeSection}>
                            <h2 style={styles.welcomeTitle}>Reset Password</h2>
                            <p style={styles.welcomeSubtitle}>
                                Enter your registered email address and we'll send you instructions to reset your password.
                            </p>
                        </div>

                        <form onSubmit={handleSubmit} style={styles.form}>
                            <div style={styles.formGroup}>
                                <label style={styles.label}>
                                    <i className="bx bx-envelope" style={styles.labelIcon}></i>
                                    Email Address
                                </label>
                                <input 
                                    type="email" 
                                    name="email" 
                                    placeholder="Enter your registered email" 
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    disabled={loading}
                                    style={styles.input}
                                />
                            </div>

                            {error && (
                                <div style={styles.errorBox}>
                                    <i className="bx bx-error-circle" style={styles.errorIcon}></i>
                                    <span style={styles.errorText}>{error}</span>
                                </div>
                            )}

                            {message && (
                                <div style={styles.successBox}>
                                    <i className="bx bx-check-circle" style={styles.successIcon}></i>
                                    <span style={styles.successText}>{message}</span>
                                </div>
                            )}

                            <button 
                                type="submit" 
                                style={{
                                    ...styles.submitButton,
                                    opacity: loading ? 0.7 : 1,
                                    cursor: loading ? 'not-allowed' : 'pointer'
                                }}
                                disabled={loading}
                            >
                                {loading ? (
                                    <>
                                        <div style={styles.spinner}></div>
                                        <span>Sending...</span>
                                    </>
                                ) : (
                                    <>
                                        <i className="bx bx-envelope" style={styles.buttonIcon}></i>
                                        <span>Send Reset Link</span>
                                    </>
                                )}
                            </button>
                        </form>

                        <div style={styles.footer}>
                            <Link to="/sign-in" style={styles.backLink}>
                                <i className="bx bx-left-arrow-alt"></i>
                                Back to Sign In
                            </Link>
                        </div>
                    </div>

                    <div style={styles.bottomDecor}>
                        <div style={styles.decorCircle1}></div>
                        <div style={styles.decorCircle2}></div>
                    </div>
                </div>
            </div>
        </main>
    );
}

const styles = {
    mainSection: {
        minHeight: '100vh',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
        position: 'relative',
        overflow: 'hidden',
    },
    background: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'linear-gradient(135deg, #0e0758 0%, #1a0d4d 50%, #0e0758 100%)',
        zIndex: -1,
    },
    container: {
        width: '100%',
        maxWidth: '440px',
        margin: '0 auto',
        position: 'relative',
        zIndex: 1,
    },
    brandContainer: {
        textAlign: 'center',
        marginBottom: '30px',
    },
    logoCircle: {
        width: '90px',
        height: '90px',
        borderRadius: '50%',
        background: '#FFFFFF',
        border: '2px solid rgba(25, 191, 177, 0.35)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0 auto 15px',
        boxShadow: '0 8px 25px rgba(0, 0, 0, 0.15)',
    },
    logoImage: {
        width: '55px',
        height: 'auto',
    },
    brandTagline: {
        fontSize: '14px',
        color: 'rgba(255, 255, 255, 0.7)',
        margin: 0,
    },
    authCard: {
        background: 'rgba(255, 255, 255, 0.05)',
        backdropFilter: 'blur(20px)',
        borderRadius: '25px',
        padding: '30px 25px',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
    },
    _iconCircle: {
        width: '70px',
        height: '70px',
        borderRadius: '50%',
        background: 'rgba(25, 191, 177, 0.15)',
        border: '2px solid rgba(25, 191, 177, 0.3)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0 auto 20px',
    },
    mainIcon: {
        fontSize: '32px',
        color: '#19bfb1',
    },
    welcomeSection: {
        textAlign: 'center',
        marginBottom: '25px',
    },
    welcomeTitle: {
        fontSize: '24px',
        fontWeight: '700',
        color: '#fff',
        margin: '0 0 12px 0',
    },
    welcomeSubtitle: {
        fontSize: '14px',
        color: 'rgba(255, 255, 255, 0.6)',
        margin: 0,
        lineHeight: '1.5',
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        gap: '18px',
    },
    formGroup: {
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
    },
    label: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        fontSize: '13px',
        fontWeight: '600',
        color: 'rgba(255, 255, 255, 0.9)',
        marginBottom: '5px',
    },
    labelIcon: {
        fontSize: '16px',
        color: '#19bfb1',
    },
    input: {
        width: '100%',
        padding: '14px 16px',
        fontSize: '16px',
        color: '#fff',
        background: 'rgba(255, 255, 255, 0.08)',
        border: '1px solid rgba(255, 255, 255, 0.15)',
        borderRadius: '12px',
        outline: 'none',
        transition: 'all 0.3s ease',
        boxSizing: 'border-box',
    },
    errorBox: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        background: 'rgba(220, 53, 69, 0.15)',
        border: '1px solid rgba(220, 53, 69, 0.3)',
        borderRadius: '12px',
        padding: '12px 15px',
    },
    errorIcon: {
        fontSize: '20px',
        color: '#dc3545',
        flexShrink: 0,
    },
    errorText: {
        fontSize: '13px',
        color: '#ff6b7a',
        lineHeight: '1.5',
    },
    successBox: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        background: 'rgba(40, 167, 69, 0.15)',
        border: '1px solid rgba(40, 167, 69, 0.3)',
        borderRadius: '12px',
        padding: '12px 15px',
    },
    successIcon: {
        fontSize: '20px',
        color: '#28a745',
        flexShrink: 0,
    },
    successText: {
        fontSize: '13px',
        color: '#5dd47f',
        lineHeight: '1.5',
    },
    submitButton: {
        width: '100%',
        padding: '16px',
        fontSize: '15px',
        fontWeight: '600',
        color: '#fff',
        background: 'linear-gradient(135deg, #19bfb1 0%, #0e9688 100%)',
        border: 'none',
        borderRadius: '12px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '10px',
        boxShadow: '0 8px 20px rgba(25, 191, 177, 0.3)',
        transition: 'all 0.3s ease',
        marginTop: '8px',
    },
    buttonIcon: {
        fontSize: '20px',
    },
    spinner: {
        width: '18px',
        height: '18px',
        border: '2px solid rgba(255, 255, 255, 0.3)',
        borderTop: '2px solid #fff',
        borderRadius: '50%',
        animation: 'spin 0.8s linear infinite',
    },
    footer: {
        textAlign: 'center',
        marginTop: '25px',
        paddingTop: '20px',
        borderTop: '1px solid rgba(255, 255, 255, 0.1)',
    },
    backLink: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '8px',
        color: '#19bfb1',
        fontSize: '14px',
        fontWeight: '600',
        textDecoration: 'none',
    },
    bottomDecor: {
        position: 'fixed',
        bottom: '-100px',
        left: '-100px',
        right: 0,
        height: '300px',
        zIndex: -1,
        pointerEvents: 'none',
    },
    decorCircle1: {
        position: 'absolute',
        width: '250px',
        height: '250px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(25, 191, 177, 0.15) 0%, transparent 70%)',
        bottom: '0',
        left: '10%',
    },
    decorCircle2: {
        position: 'absolute',
        width: '350px',
        height: '350px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(14, 7, 88, 0.4) 0%, transparent 70%)',
        bottom: '-50px',
        right: '10%',
    },
};

export default ForgotPassword;
